import { useEffect, useState } from "react";

const KEY = "ctlc-best-island";

const readBest = () => {
  const v = localStorage.getItem(KEY);
  return v === null ? null : Number(v);
};

// Best island reached on this device; isNew when the previous record has just been beaten.
export const usePersonalRecord = (destinationIndex) => {
  const [previous] = useState(readBest);
  const isNew = previous !== null && destinationIndex > previous;

  useEffect(() => {
    if (previous === null || destinationIndex > previous) localStorage.setItem(KEY, String(destinationIndex));
  }, [previous, destinationIndex]);

  return { best: Math.max(previous ?? destinationIndex, destinationIndex), previous, isNew };
};

const HISTORY_KEY = "ctlc-history";
const HISTORY_SIZE = 5;

const readHistory = () => {
  const list = JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]");
  return Array.isArray(list) ? list.filter(Number.isInteger) : [];
};

// Last 5 islands on this device, most recent first (current game included).
export const useIslandHistory = (destinationIndex) => {
  const [history] = useState(() => [destinationIndex, ...readHistory()].slice(0, HISTORY_SIZE));
  useEffect(() => localStorage.setItem(HISTORY_KEY, JSON.stringify(history)), [history]);
  return history;
};
